module.exports = {
          srcSet: __webpack_public_path__ + "public/images/a2e690b0f5832b07d3b8742b3fd46622-1200.jpg"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/a2e690b0f5832b07d3b8742b3fd46622-1200.jpg",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/a2e690b0f5832b07d3b8742b3fd46622-1200.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/a2e690b0f5832b07d3b8742b3fd46622-1200.jpg"},
          
          width: 1200,
          height: 800
        }